const appConfig = {
    version: "1.0"
};

export default appConfig;
